import React from 'react';
import {
  Box,
  ButtonBase,
  Typography,
} from '@mui/material';
import {
  CalendarTodayOutlined as CalendarIcon,
  HomeOutlined as HomeIcon,
  PersonOutlineOutlined as ProfileIcon,
  AutoAwesomeOutlined as InsightsIcon,
} from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import colors from '../../../assets/theme/colors';

const NAV_ITEMS = [
  { id: 'home', label: 'Home', Icon: HomeIcon },
  { id: 'today', label: 'Timeline', Icon: CalendarIcon },
  { id: 'profile', label: 'Care Profile', Icon: ProfileIcon },
  { id: 'tools', label: 'Insights', Icon: InsightsIcon },
];

const ChildShellBottomNav = ({
  activeItem = 'today',
  onSelect,
}) => {
  return (
    <Box
      component="nav"
      aria-label="Child sections"
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1200,
        px: { xs: 1.25, sm: 2 },
        pt: 0.8,
        pb: 'calc(env(safe-area-inset-bottom, 0px) + 0.75rem)',
        bgcolor: alpha('#FFFFFF', 0.96),
        borderTop: `1px solid ${colors.landing.borderLight}`,
        boxShadow: `0 -10px 28px ${alpha(colors.landing.shadowPanel, 0.6)}`,
        backdropFilter: 'blur(14px)',
      }}
    >
      <Box
        sx={{
          maxWidth: 720,
          mx: 'auto',
          display: 'grid',
          gridTemplateColumns: `repeat(${NAV_ITEMS.length}, minmax(0, 1fr))`,
          gap: 0.5,
        }}
      >
        {NAV_ITEMS.map(({ id, label, Icon }) => {
          const isActive = id === activeItem;

          return (
            <ButtonBase
              key={id}
              onClick={() => onSelect?.(id)}
              aria-current={isActive ? 'page' : undefined}
              sx={{
                minWidth: 0,
                minHeight: 56,
                borderRadius: '18px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 0.28,
                color: isActive ? colors.semantic.sageActionInk : colors.landing.textMuted,
                bgcolor: isActive ? colors.semantic.sageMist : 'transparent',
                transition: 'background-color 160ms ease, color 160ms ease',
                '&:hover': {
                  bgcolor: isActive ? colors.semantic.sageSoft : colors.semantic.sageMist,
                },
              }}
            >
              <Icon
                sx={{
                  fontSize: 23,
                  color: isActive ? colors.semantic.sageAction : 'inherit',
                }}
              />
              <Typography
                component="span"
                sx={{
                  fontSize: '0.72rem',
                  lineHeight: 1.05,
                  fontWeight: isActive ? 600 : 500,
                  color: 'inherit',
                  whiteSpace: 'nowrap',
                }}
              >
                {label}
              </Typography>
            </ButtonBase>
          );
        })}
      </Box>
    </Box>
  );
};

export default ChildShellBottomNav;
